import { useEffect } from 'react';
const { getCurrentBrand } = require('../../config/brands');

/**
 * BrandTheme - Applies the current brand's color theme to the document using CSS variables
 * This allows the entire application to use the brand's colors dynamically
 */
const BrandTheme = () => {
  useEffect(() => {
    const brand = getCurrentBrand();
    
    // Apply brand colors as CSS variables to the root element
    document.documentElement.style.setProperty('--primary-color', brand.primaryColor);
    document.documentElement.style.setProperty('--theme-color', brand.themeColor);
    
    // Also apply as data attributes that can be used for specific brand-based styling
    document.documentElement.dataset.brand = process.env.REACT_APP_BRAND || 'ezseat';
  }, []);

  // This component doesn't render anything visible
  return null;
};

export default BrandTheme;